"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Attachment = _interopRequireWildcard(require("./Attachment"));

var _Attachments = require("./Attachments.styles");

var _AddAttachments = _interopRequireDefault(require("./AddAttachments"));

var Attachments = function Attachments(_ref) {
  var className = _ref.className,
      attachments = _ref.attachments,
      onUploadFile = _ref.onUploadFile,
      onRemove = _ref.onRemove,
      disabled = _ref.disabled;
  if (attachments.length === 0) return null;
  return (0, _jsxRuntime.jsxs)("div", {
    className: className,
    css: [_elements.text.styles.text3Xs, _Attachments.styles.attachments, process.env.NODE_ENV === "production" ? "" : ";label:Attachments;"],
    children: [(0, _jsxRuntime.jsx)("h4", {
      className: "grui",
      children: "Attachments"
    }), attachments.map(function (attachment) {
      return (0, _jsxRuntime.jsx)(_Attachment["default"], {
        attachment: attachment,
        onRemove: onRemove,
        onUploadFile: onUploadFile,
        disabled: disabled
      }, attachment.id);
    })]
  });
};

Attachments.propTypes = {
  className: _propTypes.string,
  attachments: (0, _propTypes.arrayOf)(_Attachment.attachmentType),
  onUploadFile: _propTypes.func,
  onRemove: _propTypes.func,
  disabled: _propTypes.bool
};
Attachments.defaultProps = {
  className: undefined,
  attachments: [],
  onUploadFile: function onUploadFile() {},
  onRemove: function onRemove() {},
  disabled: false
};
Attachments.AddAttachments = _AddAttachments["default"];
var _default = Attachments;
exports["default"] = _default;
//# sourceMappingURL=Attachments.js.map